<template>
  <div class="page-container">
    <div class="doc-wrapper">
      <h1 class="main-title">{{ txt.title }}</h1>
      
      <div class="help-grid">
        <div 
          class="help-card" 
          v-for="(item, index) in txt.items" 
          :key="index"
          @click="toggleItem(index)"
          :class="{ active: activeIndex === index }"
        >
          <div class="hc-header">
            <div class="hc-icon">📄</div>
            <div class="hc-text">
              <h4>{{ item.t }}</h4>
              <p>{{ item.d }}</p>
            </div>
            <div class="hc-arrow">{{ activeIndex === index ? '▲' : '▼' }}</div>
          </div>
          <div class="hc-body" v-if="activeIndex === index">
            <div class="hc-content">{{ item.content }}</div>
          </div>
        </div>
      </div>

      <div class="announcement-box">
        <h3>📢 {{ txt.anno.title }}</h3>
        <p v-for="(news, i) in txt.anno.list" :key="i">• {{ news }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import DICT from '../locales/data.js';

export default {
  props: ['lang'],
  data() { return { activeIndex: null } },
  computed: { txt() { return DICT[this.lang].help || DICT['en'].help } },
  methods: { toggleItem(index) { this.activeIndex = this.activeIndex === index ? null : index; } }
}
</script>

<style scoped>
.page-container { padding: 40px 0 100px; background: #000; min-height: 100vh; color: #ccc; }
.doc-wrapper { max-width: 800px; margin: 0 auto; padding: 40px; }
.main-title { color: #fff; font-size: 28px; font-weight: 800; margin-bottom: 40px; }
.help-grid { display: flex; flex-direction: column; gap: 15px; margin-bottom: 50px; }
.help-card { background: #14151a; border: 1px solid #222; border-radius: 12px; overflow: hidden; transition: 0.2s; cursor: pointer; }
.help-card:hover { border-color: #00D092; }
.help-card.active { border-color: #00D092; background: rgba(0,208,146,0.02); }
.hc-header { display: flex; align-items: center; padding: 20px; }
.hc-icon { font-size: 24px; margin-right: 20px; opacity: 0.7; }
.hc-text { flex: 1; }
.hc-text h4 { margin: 0 0 5px 0; color: #fff; font-size: 16px; }
.hc-text p { margin: 0; font-size: 13px; color: #666; }
.hc-arrow { color: #444; transition: 0.3s; }
.help-card.active .hc-arrow { transform: rotate(180deg); color: #00D092; }
.hc-body { padding: 0 20px 20px 64px; animation: slideDown 0.3s ease; }
.hc-content { font-size: 14px; color: #aaa; line-height: 1.8; white-space: pre-line; }
.announcement-box { background: rgba(0,208,146,0.05); padding: 30px; border-radius: 12px; border: 1px dashed rgba(0,208,146,0.3); }
.announcement-box h3 { color: #00D092; font-size: 16px; margin-top: 0; margin-bottom: 15px; }
.announcement-box p { color: #aaa; font-size: 13px; margin-bottom: 10px; cursor: pointer; }
.announcement-box p:hover { color: #fff; text-decoration: underline; }
@keyframes slideDown { from {opacity: 0; transform: translateY(-10px);} to {opacity: 1; transform: translateY(0);} }
@media(max-width: 768px) { .doc-wrapper { padding: 20px; } .hc-body { padding-left: 20px; } }
</style>